import { Flex } from 'onefaceui-react-components';
import { styled, keyframes } from 'styled-components';

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled(Flex)`
  background-color: #C0330026;
  padding: 12px;
  gap: 12px;
  border: solid var(--red-400) 2px;
  border-radius: 2px;
  margin-top: 16px;
  animation: ${fadeInUp} 0.3s ease forwards;

  button {
    min-width: 130px;
  }
`;
